import React, { useState } from 'react';
import {
  ConsultFormContainer,
  LeadSubmitContainer,
  RequestCallbackBtn,
} from './styled';
import { images } from '../../../Constants/ImageUrls';

function LeadSubmit(props) {
  const { closePopup, bookingDoneData, isConsultPage } = props;
  const [cardEffect, setCardEffect] = useState('');
  return (
    <>
      <ConsultFormContainer isConsultPage={isConsultPage}>
        <LeadSubmitContainer isConsultPage={isConsultPage}>
          <img src={images?.tick_consult} alt="" />
          <p className="details">We have received your details</p>
          <p className="desc">
            {` Our Customer Care agent will reach you shortly on
                        +91-${bookingDoneData} to schedule your call.`}
          </p>
          <RequestCallbackBtn
            className={`${cardEffect}`}
            onClick={() => {
              setTimeout(() => {
                closePopup();
              }, 100);

              setCardEffect('lowOpacity');
            }}
          >
            <span></span>CONTINUE
          </RequestCallbackBtn>
        </LeadSubmitContainer>
      </ConsultFormContainer>
    </>
  );
}

export default LeadSubmit;
